import { t } from "@lingui/macro";
import React from "react";
import InformationPill from "~/applications/OfferSearch/Ui/OfferDetails/InformationPill";
import { Door } from "~/guidelines/Icon";
import ListItemWithIcon from "~/guidelines/ListItemWithIcon";

export type ConnectingDoorAmenityProps = {
  variant?: "list-item" | "pill";
  highlightConnectingDoor: boolean;
};

const ConnectingDoorAmenity = ({
  variant = "list-item",
  highlightConnectingDoor,
}: ConnectingDoorAmenityProps) => {
  if (!highlightConnectingDoor) {
    return null;
  }

  const textChildren = t`Connecting door`;

  if (variant === "pill") {
    return <InformationPill icon={<Door />} text={textChildren} />;
  }

  return <ListItemWithIcon icon={<Door />}>{textChildren}</ListItemWithIcon>;
};

export default ConnectingDoorAmenity;
